// @ts-nocheck - Kallos 2.2.0 has React 18 TypeScript compatibility issues with ForwardRefExoticComponent
import React, { useEffect, useState, useMemo } from 'react';
import useQuery from 'reusable/customHooks/useQuery';
import Badges from '.';
import { Button, Spinner, ThemeProvider } from '@alphonsocode/kallos';
import { BadgeStyle } from './style';

interface BadgeData {
  key: string;
  value: string | '';
  labelForQuery: string;
}

export function HomeBadgeComponent({
  isFetching,
  isLoading,
  filters,
  isChecked,
  setIsChecked,
  isMyTestsChecked,
  setIsMyTestsChecked,
}) {
  const [query, setQuery] = useQuery();
  const [badges, setBadges] = useState<BadgeData[]>([]);
  const [isCampaign, setIsCampaign] = useState(isChecked);
  const [globalSearch, setGlobalSearch] = useState(query.get('gSearch'));
  const [mosaicRedirect, setMosaicRedirect] = useState(
    query.get('mosaicRedirect'),
  );

  const badgeExcludelist = useMemo(
    () => [
      'startDate',
      'endDate',
      'myCampaigns',
      'myTests',
      'gSearch',
      'limit',
      'page',
      'testTag',
      'mosaicRedirect',
    ],
    [],
  );

  const handleBadgeClose = indexToRemove => {
    const updated = [...badges];
    const toRemove = updated[indexToRemove];
    const idx = badges.findIndex(item => item.key === toRemove.key);
    if (idx !== -1) {
      updated.splice(idx, 1);
      setQuery({ [toRemove.labelForQuery]: '', page: '1' });
      setBadges(updated);
    }
  };

  useEffect(() => {
    if (!filters?.length) return;

    const queryKeys = Array.from(query.keys());
    const newBadges = queryKeys
      .filter(key => !badgeExcludelist.includes(key))
      .map(key => {
        const filterMeta = filters.find(item => item.key === key);
        return {
          key: filterMeta?.label || key,
          value: query.get(key) || '',
          labelForQuery: key,
        };
      });
    setBadges(newBadges);
  }, [query, filters, badgeExcludelist]);

  useEffect(() => {
    setIsCampaign(isChecked);
    setGlobalSearch(query.get('gSearch'));
    setMosaicRedirect(query.get('mosaicRedirect'));
  }, [query, isChecked]);

  const resetFilters = () => {
    const clearedBadgeFilters = badges.reduce<Record<string, string>>(
      (acc, item) => ({
        ...acc,
        [item.labelForQuery]: '',
      }),
      {},
    );

    setBadges([]);
    setMosaicRedirect(null);
    setGlobalSearch(null);
    setIsCampaign(false);
    setIsChecked(false);
    setIsMyTestsChecked(false);
    setQuery({
      ...clearedBadgeFilters,
      myTests: '',
      myCampaigns: 'false',
      gSearch: '',
      mosaicRedirect: '',
      page: '1',
    });
  };

  const handleClose = () => {
    setIsChecked(false);
    setQuery('myCampaigns', '');
  };
  const handleMyTestClose = () => {
    setIsMyTestsChecked(false);
    setQuery('myTests', '');
  };

  return (
    <BadgeStyle>
      {/* @ts-ignore - ThemeProvider children type issue with React 18 */}
      <ThemeProvider defaultMode="light">
        <div
          className="badgeDiv d-flex justify-content-start"
          style={{
            display: 'flex',
            alignItems: 'center',
            flexWrap: 'nowrap',
            overflowX: 'auto',
            marginTop: -2,
          }}
        >
          <Button
            colorVariant="secondary"
            variant="borderless"
            disableHoverEffect={true}
            onClick={resetFilters}
            style={{
              fontFamily: 'lg-smart, sans-serif',
              fontSize: 12,
              fontWeight: 600,
              lineHeight: '18px',
              marginTop: 0,
              marginRight: 12,
              marginLeft: 2,
              whiteSpace: 'nowrap',
              flexShrink: 0,
            }}
          >
            Clear All
          </Button>
          {isFetching || isLoading ? (
            <Spinner variant="deepGreen" />
          ) : (
            <div style={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
              {isCampaign === true && (
                <Badges
                  items={[{ key: 'My Campaigns', value: '' }]}
                  variant="lgRed"
                  onClose={handleClose}
                  enableTooltip={false}
                />
              )}
              {isMyTestsChecked === true && (
                <Badges
                  items={[{ key: 'My Tests', value: '' }]}
                  variant="lgGreen"
                  onClose={handleMyTestClose}
                  enableTooltip={false}
                />
              )}
              {globalSearch ? (
                <Badges
                  items={[
                    {
                      key: 'Global Search',
                      value: globalSearch,
                      showFullValue: false,
                    },
                  ]}
                  variant="lgWebGreen"
                  onClose={() => setQuery('gSearch', '')}
                />
              ) : null}
              {mosaicRedirect ? (
                <Badges
                  items={[
                    {
                      key: 'Mosaic View',
                      value: mosaicRedirect,
                      showFullValue: false,
                    },
                  ]}
                  variant="danger"
                  onClose={() => setQuery('mosaicRedirect', '')}
                />
              ) : null}
              <Badges
                items={badges.map(e => ({ key: e.key, value: e.value }))}
                variant="lgDeepGreen"
                onClose={handleBadgeClose}
              />
            </div>
          )}
        </div>
      </ThemeProvider>
    </BadgeStyle>
  );
}
